import { useContext } from "react";
import AuthContext from "../context/AuthContext_Provider"

const useAuth = () => {
    return useContext(AuthContext)
}

export default useAuth
